module.exports = __webpack_public_path__ + "img/00028.d6fa1524.webp";